import { zodResolver } from '@hookform/resolvers/zod'
import { Resolver, useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { getOrderFormSchema, OrderFormValues } from './shema'

export const useOrderForm = () => {
  const { t: o } = useTranslation('order')
  // const form = useForm<z.infer<typeof formSchema>>({
  //   resolver: zodResolver(formSchema),
  //   defaultValues: {
  //     apartment: '',
  //     floor: selectedAddress?.address_floor ?? '',
  //     entrance: selectedAddress?.address_porch ?? '',
  //     intercom: selectedAddress?.address_intercom ?? '',
  //     comment: '',
  //     title: selectedAddress?.label ?? '',
  //     otherBuyer: selectedAddress?.other_recipient ?? false,
  //     otherBuyerName: selectedAddress?.recipient_name ?? '',
  //     otherBuyerPhone: selectedAddress?.recipient_phone ?? '',
  //   },
  // })
  const form = useForm<OrderFormValues>({
    resolver: zodResolver(getOrderFormSchema(o)) as Resolver<OrderFormValues>,
    defaultValues: {
      name: '',
      phone: '',
      isOtherPerson: false,
      nameOther: '',
      phoneOther: '',
      address: '',
      isPrivateHouse: false,
      comment: '',
      noIntercomCall: false,
      leaveAtDoor: false,
      replacementOption: 1,
      commentBuilder: '',
      packages: false,
      pickup: false,
      apartment: '',
      floor: '',
      entrance: '',
      intercom: '',
    },
  })

  return form
}
